import './AppDescriptionCellEditor.scss';
import { APP_VALIDATION_RULES } from '../../@arch/validation';
import classNames from 'classnames';
import { PlaintextCellEditor } from '@ui/text';
import React, { useCallback } from 'react';
import { useAsyncProcessing, useCurrentUser, useUpdateDataSecurityApp } from '@hooks';
export const AppDescriptionCellEditor = ({ applicationId, description }) => {
    const { request, reset } = useUpdateDataSecurityApp();
    const { isReadOnly } = useCurrentUser();
    const process = useAsyncProcessing({
        resetAction: reset,
        stateSelector: useUpdateDataSecurityApp.selectors.state
    });
    const handleOnSave = useCallback((value) => {
        if (description === value) {
            return;
        }
        process.watchNextCall();
        request({
            applicationId,
            description: value
        });
    }, [applicationId, description, process, request]);
    return (React.createElement(PlaintextCellEditor, { allowNewline: true, className: classNames('app-description-cell-editor', { readonly: isReadOnly }), isProcessing: process.state.isProcessing, onSave: handleOnSave, processingResult: process.state.result, rules: APP_VALIDATION_RULES.DESCRIPTION, value: description }));
};
